import React, { Component } from "react";
import { connect } from "react-redux";
import { propertyConditionNames } from "@appcues/libcues";
import BaseClause from "components/Common/Clauses/Base";
import { getEmptyClauseForConditionName } from "utils/conditions";
import { selectFlows } from "reducers/account/flows";
import { selectAccountSegments } from "reducers/account/segments";
import { selectAccountUserEvents } from "reducers/account/userEvents";
import ToggleableSelect from "components/Common/Clauses/ToggleableSelect";

class AudienceBaseClause extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      clause,
      replaceClause,
      hasSteps,
      hasEvents,
      hasSegments,
      readOnly,
      skipSegments
    } = this.props;

    let conditionNameOptions = [
      { value: propertyConditionNames.PROPERTIES, label: "Property" },
      { value: propertyConditionNames.LANGUAGES, label: "Language" },
      {
        value: propertyConditionNames.CONTENT,
        label: "Flow",
        disabled: !hasSteps
      },
      {
        value: propertyConditionNames.EVENT,
        label: "Event",
        disabled: !hasEvents
      }
    ];

    if (!skipSegments) {
      conditionNameOptions.push({
        value: propertyConditionNames.SEGMENTS,
        label: "Segment",
        disabled: !hasSegments
      });
    }

    const displayValue = conditionNameOptions.find(
      option => option.value === clause.conditionName
    );

    return (
      <BaseClause {...this.props}>
        <ToggleableSelect
          readOnly={readOnly}
          readOnlyContent={displayValue && displayValue.label}
          className="select-condition-name"
          clearable={false}
          value={clause.conditionName}
          options={conditionNameOptions}
          onChange={opt =>
            replaceClause(clause.id, getEmptyClauseForConditionName(opt.value))
          }
          operator
        />
        {this.props.children}
      </BaseClause>
    );
  }
}

function mapStateToProps(state) {
  return {
    hasSteps: Object.keys(selectFlows(state)).length,
    hasEvents: Object.keys(selectAccountUserEvents(state)).length,
    hasSegments: Object.keys(selectAccountSegments(state)).length
  };
}

export default connect(mapStateToProps)(AudienceBaseClause);
